import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { SessionSotrageService } from '../../../../services/session-sotrage.service';
import { User } from 'src/app/model/session/user.model';
import { CatalogosService } from '../../../../services/catalogos/catalogos.service';
import { ComunicacionService } from '../../../../services/comunicacion.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  selectedLanguage: string;
  public lang: string;
  public user: User;
  public traduccion = environment.traduccion;
  ambiente = environment.ambiente;
  razonSocialNombre: string = '';
  almacenNombre: string = '';
  actividadVulnerable: string = '';

  constructor(
    private translateService: TranslateService, 
    private sssotrage: SessionSotrageService,
    private catalogoService: CatalogosService, 
    private comunicacionService: ComunicacionService,
    private router: Router) {
    this.selectedLanguage = comunicacionService.getLenguaje();
    this.lang = comunicacionService.getLenguaje();
    this.translateService.setDefaultLang(this.selectedLanguage);
    const browserLang = translateService.getBrowserLang();
    translateService.use(this.selectedLanguage);
  }

  toogleLanguage(lang: string) {
    this.translateService.use(lang);
    this.lang = lang;
    this.comunicacionService.setLenguaje(lang);
  }

  ngOnInit() {
    this.user = this.sssotrage.getCurrentUser();
    const session = this.sssotrage.getCurrentSession();
    this.razonSocialNombre = session?.razonSocialNombre || 'No definida';
    this.almacenNombre = session?.almacenNombre
      ? session.almacenNombre.toUpperCase()
      : 'TODOS';
    this.actividadVulnerable = session?.actividadVulnerable.toUpperCase() || '';

  }

  cerrarSesion(): void {
    this.catalogoService.limpiarCatalogos(false);
    this.sssotrage.logout();
  }
}
